<template>
  <div class="navbar-item">
    <div class="select is-fullwidth">
      <select v-model="$i18n.locale" @change="updateRoute">
        <option value="en">{{ $t("navigation.english") }}</option>
        <option value="fr">{{ $t("navigation.french") }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocaleSwitcher",
  methods: {
    updateRoute() {
      var lang = this.$i18n.locale;
      var path = this.$route.path.replace(/\/../, "/" + lang);
      this.$router.push({ path: path });
      location.reload();
    },
  },
};
</script>